/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import {
  ContextualMenu,
  ContextualMenuItem,
  Button as ForgeCommonButton,
  Button,
  MoreVerticalIcon,
  TrashIcon,
  EditIcon, 
} from "@forge/common";
import GetTokenValues from "../../../utils/methods/GetTokenValues";
import { WrapperUserPermissions } from "../../../models";
import { isEditButtonDisabled } from "../../../utils/methods/editDisableonPersona";
import { isDeleteButtonEnabled } from "../../../utils/methods/deleteDisableonPersona";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../../localization/keys";
import { USER_STATUS } from "../../../utils/constants";

export const ActionCell = (actionCellProps: any) => {
  const { cellValues, props } = actionCellProps;
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [t] = useTranslation();
  const userPermissions: WrapperUserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );

  const userPersonaLoggedin = userPermissions.user_persona;

  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer ?? "",
    tenant: accessTokenPayload?.ext?.tenant_id ?? "",
    userId: accessTokenPayload?.sub ?? "",
  };
  const isLoggedInUser = cellValues?.row?.userId === tokenInfo.userId;

  // @TODO:Revert if required. Currently not using roleVal
  // let roleVal = null;
  // if (props.component === "distributor") {
  //   const getRoleValue = cellValues?.row?.roles?.map((item: any) =>
  //     item.name.includes("Distributor")
  //   );
  //   for (const key in getRoleValue) {
  //     if (getRoleValue.hasOwnProperty(key) && getRoleValue[key]) {
  //       roleVal = true;
  //       break;
  //     }
  //   }
  // }

  return (
    <div style={{ display: "flex", alignItems: "center", gap: ".2rem" }}>
      <ForgeCommonButton
        className="edit-delete-button-datagrid"
        variant={
          !isEditButtonDisabled({
            component: props.component,
            isLoggedInUser: isLoggedInUser,
            userPersonaLoggedin: userPersonaLoggedin,
            OrganizationInformation: props.OrganizationInformation,

            cellValues: cellValues,
          })
            ? "quiet-secondary"
            : "quiet-primary"
        }
        //variant="quiet-primary"
        data-testid="editbuttonrow"
        onClick={() => {
          props.handleEdit(cellValues);
        }}
        disabled={
          !isEditButtonDisabled({
            OrganizationInformation: props.OrganizationInformation,
            component: props.component,
            isLoggedInUser: isLoggedInUser,
            userPersonaLoggedin: userPersonaLoggedin,
            cellValues: cellValues,
          })
          //   props.component !== "tenantUserPage" &&
          //   ((props.component === "orgAdmin" &&
          //     cellValues.row.roles.filter(
          //       (el: any) => el.name === "Organization Admin"
          //     ).length) ||
          //     (props.component === "organizationUserList" &&
          //       !isEditForOrgUserButtonDisabled))
        }
      >
        <EditIcon data-testid="edit-icon" />
      </ForgeCommonButton>
      {props.component !== "honeywellUserPage" && (
        <ForgeCommonButton
          className="edit-delete-button-datagrid"
          variant={
            !isDeleteButtonEnabled({
              component: props.component,
              isLoggedInUser: isLoggedInUser,
              userPersonaLoggedin: userPersonaLoggedin,
              cellValues: cellValues,
              OrganizationInformation: props.OrganizationInformation,
              userPermissions: userPermissions,
            })
              ? "quiet-secondary"
              : "quiet-primary"
          }
          onClick={() => {
            props.handleDelete(cellValues);
          }}
          disabled={
            !isDeleteButtonEnabled({
              component: props.component,
              isLoggedInUser: isLoggedInUser,
              userPersonaLoggedin: userPersonaLoggedin,
              cellValues: cellValues,
              OrganizationInformation: props.OrganizationInformation,
              userPermissions: userPermissions,
            })
          }
        >
          <TrashIcon data-testid="delete-icon" />
        </ForgeCommonButton>
      )}
      <Button
        ref={anchorRef}
        variant="quiet-secondary"
        icon={<MoreVerticalIcon strokeWidth={2.5} />}
        aria-label={t(localeKeyMap.more)}
      />
      <ContextualMenu anchor={anchorRef}>
        <ContextualMenuItem
          as="button"
          id="deactivateUser"
          label={t(localeKeyMap.deactivateUser)}
          onClick={() => {
            if (props.handleDeactivate) {
              props.handleDeactivate(cellValues);
            }
          }}
          disabled={
            isLoggedInUser ||
            cellValues?.row?.status === USER_STATUS.PENDING ||
            cellValues?.row?.status === USER_STATUS.INACTIVE
          }
        />
        <ContextualMenuItem
          as="button"
          id="activateUser"
          label={t(localeKeyMap.activateUser)}
          onClick={() => {
            if (props.handleActivate) {
              props.handleActivate(cellValues);
            }
          }}
          disabled={
            isLoggedInUser ||
            cellValues?.row?.status === USER_STATUS.PENDING ||
            cellValues?.row?.status === USER_STATUS.ACTIVE
          }
        />
        <ContextualMenuItem
          as="button"
          id="resetPassword"
          label={t(localeKeyMap.resetPassword)}
          onClick={() => {
            if (props.handleResetPassword) {
              props.handleResetPassword(cellValues);
            }
          }}
        />
      </ContextualMenu>
    </div>
  );
};
export default ActionCell;
